import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterLink } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FormsModule } from "@angular/forms";
import { SanitizerPipe } from "../pipes/sanitizer.pipe";
import { AccessibleClickDirective } from "../directives/accessible-click.directive";
import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { OnlyLattersDirective } from "../directives/only-letters.directive";
import { OnlyNumberDirective } from "../directives/onlyNumber.directive";
import { AllowDecimalDirective } from "../directives/allowDecimal.directive";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
@NgModule({
  imports: [
    CommonModule,
    RouterLink,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    SanitizerPipe,
    AccessibleClickDirective,
    OnlyNumberDirective,
    OnlyLattersDirective,
    AllowDecimalDirective,
    MatTooltipModule,
    RouterLink,
    MatDialogModule,
  ],
  exports: [
    CommonModule,
    RouterLink,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    SanitizerPipe,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule,
    MatPaginatorModule,
    OnlyNumberDirective,
    OnlyLattersDirective,
    AllowDecimalDirective,
    MatTooltipModule,
    RouterLink,
    MatDialogModule,
  ],
})
export class SharedModule {}
